import PropTypes from 'prop-types';


export const propTypes = {
  transparent: PropTypes.bool,
};

export const defaultProps = {
  transparent: true,
};